import React, {createContext, useReducer} from "react";
import produce from "immer";
import {has, set} from "lodash";

const initialState = {
    progress: "lookup",
    account: {
        number: false,
        balance: 0,
    },
    amount: 0,
    env: 'prod',
};

const store = createContext(initialState);
const {Provider} = store;

const reducer = (prevState, payload) => {
    if (payload.constructor === Function) {
        return {...prevState, ...payload(prevState)};
    }

    if (payload.constructor === Object) {
        if (has(payload, "_path") && has(payload, "_value")) {
            const {_path, _value} = payload;

            return produce(prevState, draft => {
                set(draft, _path, _value);
            });
        } else {
            return {...prevState, ...payload};
        }
    }
    return {...prevState};
};

const StateProvider = ({children}) => {
    const [state, setState] = useReducer(reducer, initialState);

    return (
        <Provider value={{state, setState}}>
            {children}
        </Provider>
    );
};

export {store, StateProvider};
